import React, { Component } from 'react';
import { Form } from '@ant-design/compatible';
import { connect } from 'react-redux';
import produce from 'immer';
import OrderItemReturnExchangeRequestModal from '../../../../views/order/common/modal/OrderItemReturnExchangeRequestModal';
import { orderActions } from '../../../../store/modules/order';
import { EXCHANGE_RETURN_REQUEST_TYPE } from '../../../../constants/service/app/orderConstants';
import { updateStoreWithPath } from '../../../../lib/common';
import withModal from '../../../../lib/hoc/withModal';

class OrderItemReturnExchangeRequestModalContainer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      //--> 요청 타입
      requestType: null,
      //--> 요청 사유 타입
      requestReasonType: null,
      //--> 요청 사유
      requestReason: null,
      //--> 요청 이미지
      requestAttachment: [],
      //--> 환불 받을 은행 ID
      bankId: props.data.bankId || null,
      //--> 환불 받을 계좌번호
      bankNumber: props.data.bankNumber || null,
      //--> 환불 받을 예금주
      bankHolder: props.data.bankHolder || null,
    };
  }

  /**
   * 모달 닫기
   */
  closeModal = () => {
    this.props.toggleModal({ name: 'orderItemReturnExchangeRequestModal' });
  };

  /**
   * 데이터 변경
   */
  setData = (data) => {
    this.setState({
      [data.name]: data.value,
    });
  };

  /**
   *  이미지 업로드
   */
  imgUpload = (data) => {
    this.setState(
      produce((draft) => {
        updateStoreWithPath(data.path, data.value, draft);
      }),
    );
  };

  /**
   *  교환/반품 요청
   */
  onSubmit = () => {
    const { form, data, orderExchangeRequest, orderReturnRequest } = this.props;
    const { requestType, requestReasonType, requestReason, requestAttachment, bankId, bankNumber, bankHolder } =
      this.state;
    const { orderItemId } = data;

    form.validateFieldsAndScroll({ scroll: { offsetBottom: 100 } }, (err) => {
      if (err) return;

      /**
       *  교환요청
       */
      if (requestType === EXCHANGE_RETURN_REQUEST_TYPE.EXCHANGE) {
        orderExchangeRequest({
          orderItemId,
          type: requestReasonType,
          reason: requestReason,
          attachment: requestAttachment,
        });
      } else if (requestType === EXCHANGE_RETURN_REQUEST_TYPE.RETURN) {
        /**
         *  반품요청
         */
        orderReturnRequest({
          orderItemId,
          type: requestReasonType,
          reason: requestReason,
          attachment: requestAttachment,
          bankId,
          bankNumber,
          bankHolder,
        });
      }
    });
  };

  render() {
    const { form, isOpen, data } = this.props;

    return (
      <OrderItemReturnExchangeRequestModal
        {...this.state}
        form={form}
        isOpen={isOpen}
        data={data}
        closeModal={this.closeModal}
        setData={this.setData}
        imgUpload={this.imgUpload}
        onSubmit={this.onSubmit}
      />
    );
  }
}

const mapStateToProps = (state) => {
  return {
    isOpen: state.order.orderItemReturnExchangeRequestModal.isOpen,
    data: state.order.orderItemReturnExchangeRequestModal.data,
  };
};

const mapDispatchToProps = {
  toggleModal: orderActions.toggleModal,
  orderExchangeRequest: orderActions.orderExchangeRequest,
  orderReturnRequest: orderActions.orderReturnRequest,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withModal()(Form.create({})(OrderItemReturnExchangeRequestModalContainer)));
